import { noop } from 'lodash'
import { useState } from 'react'
import { CONTAINER_QUERY_BREAKPOINTS, cq } from '~/common/containerQuery'
import { mergeRefs } from '~/common/reactUtils'
import { $thm } from '~/common/themeSx'
import { useBoundingClientRect } from '~/hooks/useBoundingClientRect'
import { useLatestCallbackRef } from '~/hooks/useLatestRef'
import { Card } from '../../../components/cards/Cards'
import { RegionErrorBoundary } from '../../../components/empty_states/EmptyStates'
import { Flex, forwardRef } from '../../../chakra'
import { SplitListContext, SplitListProps } from './context'

export const SplitListRoot = forwardRef(
  ({ children, index, onChange: onChangeOuter = noop, ...props }: SplitListProps, outerRef) => {
    const [isMobile, setIsMobile] = useState(false)
    const refCb = useBoundingClientRect(rect => {
      if (process.env.NODE_ENV === 'test') return
      // width is 0 when hidden (e.g. inside a display:none TabPanel)
      if (rect.width === 0) return
      setIsMobile(rect.width < CONTAINER_QUERY_BREAKPOINTS['2xl'])
    })
    const [drawerIsOpen, setDrawerIsOpen] = useState(false)
    const onChange = useLatestCallbackRef(onChangeOuter)

    return (
      <SplitListContext {...{ index, onChange, isMobile, drawerIsOpen, setDrawerIsOpen }}>
        <Card
          data-split-list
          ref={mergeRefs(refCb, outerRef)}
          {...props}
          sx={$thm({
            containerType: 'inline-size',
            containerName: 'splitList',
            p: { $base: 0, $canvas: 2 },
            '[data-canvas-theme] [data-bulk-actions-banner] + &': {
              borderTop: 'none',
              borderTopRadius: 0
            },
            ...props.sx
          })}>
          <Flex
            sx={cq({
              w: 'full',
              h: 'full',
              gap: 0,
              flexDir: { '@splitList/default': 'row', '@splitList/base': 'column', '@splitList/2xl': 'row' }
            })}>
            <RegionErrorBoundary>{children}</RegionErrorBoundary>
          </Flex>
        </Card>
      </SplitListContext>
    )
  }
)

SplitListRoot.displayName = 'SplitList'
